import {
  $deactivate,
  $getAuthToken,
  $getAuthUrl,
  deactivate,
  getAuthToken,
  getAuthUrl,
} from './actionCreators';
import sagas from './sagas';

export default {
  sagas,
  actions: {
    getAuthUrl,
    getAuthToken,
    deactivate,
  },
};

export const $actions = {
  getAuthUrl: $getAuthUrl,
  getAuthToken: $getAuthToken,
  deactivate: $deactivate,
};
